const AllDistrict = [
    {
      id: "1",
      division_id: "1",
      district_name: "Comilla",
      bn_name: "কুমিল্লা",
      upazila_name: "Comilla Sadar",
      lat: "23.4682747",
      lon: "91.1788135",
      url: "www.comilla.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "2",
      division_id: "1",
      district_name: "Feni",
      bn_name: "ফেনী",
      upazila_name: "Feni Sadar",
      lat: "23.023231",
      lon: "91.3840844",
      url: "www.feni.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "3",
      division_id: "1",
      district_name: "Brahmanbaria",
      bn_name: "ব্রাহ্মণবাড়িয়া",
      upazila_name: "Brahmanbaria Sadar",
      lat: "23.9570904",
      lon: "91.1119286",
      url: "www.brahmanbaria.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "4",
      division_id: "1",
      district_name: "Rangamati",
      bn_name: "রাঙ্গামাটি",
      upazila_name: "Rangamati Sadar",
      lat: "22.65561018",
      lon: "92.17541121",
      url: "www.rangamati.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "5",
      division_id: "1",
      district_name: "Noakhali",
      bn_name: "নোয়াখালী",
      upazila_name: "Noakhali Sadar",
      lat: "22.869563",
      lon: "91.099398",
      url: "www.noakhali.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "6",
      division_id: "1",
      district_name: "Chandpur",
      bn_name: "চাঁদপুর",
      upazila_name: "Chandpur Sadar",
      lat: "23.2332585",
      lon: "90.6712912",
      url: "www.chandpur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "7",
      division_id: "1",
      district_name: "Lakshmipur",
      bn_name: "লক্ষ্মীপুর",
      upazila_name: "Lakshmipur Sadar",
      lat: "22.942477",
      lon: "90.841184",
      url: "www.lakshmipur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "8",
      division_id: "1",
      district_name: "Chattogram",
      
      bn_name: "চট্টগ্রাম",
      upazila_name: "Chattogram Sadar",
      lat: "22.335109",
      lon: "91.834073",
      url: "www.chittagong.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "9",
      division_id: "1",
      district_name: "Coxsbazar",
      bn_name: "কক্সবাজার",
      upazila_name: "Cox's Bazar Sadar",
      lat: "21.44315751",
      lon: "91.97381741",
      url: "www.coxsbazar.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "10",
      division_id: "1",
      district_name: "Khagrachhari",
      bn_name: "খাগড়াছড়ি",
      upazila_name: "Khagrachhari Sadar",
      lat: "23.119285",
      lon: "91.984663",
      url: "www.khagrachhari.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "11",
      division_id: "1",
      district_name: "Bandarban",
      bn_name: "বান্দরবান",
      upazila_name: "Bandarban Sadar",
      lat: "22.1953275",
      lon: "92.2183773",
      url: "www.bandarban.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "12",
      division_id: "2",
      district_name: "Sirajganj",
      bn_name: "সিরাজগঞ্জ",
      upazila_name: "Sirajganj Sadar",
      lat: "24.4533978",
      lon: "89.7006815",
      url: "www.sirajganj.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "13",
      division_id: "2",
      district_name: "Pabna",
      bn_name: "পাবনা",
      upazila_name: "Pabna Sadar",
      lat: "23.998524",
      lon: "89.233645",
      url: "www.pabna.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "14",
      division_id: "2",
      district_name: "Bogura",
      bn_name: "বগুড়া",
      upazila_name: "Bogura Sadar",
      lat: "24.8465228",
      lon: "89.377755",
      url: "www.bogra.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "15",
      division_id: "2",
      district_name: "Rajshahi",
      bn_name: "রাজশাহী",
      upazila_name: "Rajshahi Sadar",
      lat: "24.37230298",
      lon: "88.56307623",
      url: "www.rajshahi.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "16",
      division_id: "2",
      district_name: "Natore",
      bn_name: "নাটোর",
      upazila_name: "Natore Sadar",
      lat: "24.420556",
      lon: "89.000282",
      url: "www.natore.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "17",
      division_id: "2",
      district_name: "Joypurhat",
      bn_name: "জয়পুরহাট",
      upazila_name: "Joypurhat Sadar",
      lat: "25.09636876",
      lon: "89.04004280",
      url: "www.joypurhat.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "18",
      division_id: "2",
      district_name: "Chapainawabganj",
      bn_name: "চাঁপাইনবাবগঞ্জ",
      upazila_name: "Chapainawabganj Sadar",
      lat: "24.5965034",
      lon: "88.2775122",
      url: "www.chapainawabganj.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "19",
      division_id: "2",
      district_name: "Naogaon",
      bn_name: "নওগাঁ",
      upazila_name: "Naogaon Sadar",
      lat: "24.83256191",
      lon: "88.92485205",
      url: "www.naogaon.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "20",
      division_id: "3",
      district_name: "Jashore",
      bn_name: "যশোর",
      upazila_name: "Jashore Sadar",
      lat: "23.16643",
      lon: "89.2081126",
      url: "www.jessore.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "22",
      division_id: "3",
      district_name: "Meherpur",
      bn_name: "মেহেরপুর",
      upazila_name: "Meherpur Sadar",
      lat: "23.762213",
      lon: "88.631821",
      url: "www.meherpur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "23",
      division_id: "3",
      district_name: "Narail",
      bn_name: "নড়াইল",
      upazila_name: "Narail Sadar",
      lat: "23.172534",
      lon: "89.512672",
      url: "www.narail.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "24",
      division_id: "3",
      district_name: "Chuadanga",
      bn_name: "চুয়াডাঙ্গা",
      upazila_name: "Chuadanga Sadar",
      lat: "23.6401961",
      lon: "88.841841",
      url: "www.chuadanga.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "25",
      division_id: "3",
      district_name: "Kushtia",
      bn_name: "কুষ্টিয়া",
      upazila_name: "Kushtia Sadar",
      lat: "23.901258",
      lon: "89.120482",
      url: "www.kushtia.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "26",
      division_id: "3",
      district_name: "Magura",
      bn_name: "মাগুরা",
      upazila_name: "Magura Sadar",
      lat: "23.487337",
      lon: "89.419956",
      url: "www.magura.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "27",
      division_id: "3",
      district_name: "Khulna",
      bn_name: "খুলনা",
      upazila_name: "Khulna Sadar",
      lat: "22.815774",
      lon: "89.568679",
      url: "www.khulna.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "28",
      division_id: "3",
      district_name: "Bagerhat",
      bn_name: "বাগেরহাট",
      upazila_name: "Bagerhat Sadar",
      lat: "22.651568",
      lon: "89.785938",
      url: "www.bagerhat.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "29",
      division_id: "3",
      district_name: "Jhenaidah",
      bn_name: "ঝিনাইদহ",
      upazila_name: "Jhenaidah Sadar",
      lat: "23.5448176",
      lon: "89.1539213",
      url: "www.jhenaidah.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "30",
      division_id: "4",
      district_name: "Jhalakathi",
      bn_name: "ঝালকাঠি",
      upazila_name: "Jhalakathi Sadar",
      lat: "22.6422689",
      lon: "90.2003932",
      url: "www.jhalakathi.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "31",
      division_id: "4",
      district_name: "Patuakhali",
      bn_name: "পটুয়াখালী",
      upazila_name: "Patuakhali Sadar",
      lat: "22.3596316",
      lon: "90.3298712",
      url: "www.patuakhali.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "32",
      division_id: "4",
      district_name: "Pirojpur",
      bn_name: "পিরোজপুর",
      upazila_name: "Pirojpur Sadar",
      lat: "22.5781398",
      lon: "89.9983909",
      url: "www.pirojpur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "33",
      division_id: "4",
      district_name: "Barisal",
      bn_name: "বরিশাল",
      upazila_name: "Barisal Sadar",
      lat: "22.7004179",
      lon: "90.3731568",
      url: "www.barisal.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "34",
      division_id: "4",
      district_name: "Bhola",
      bn_name: "ভোলা",
      upazila_name: "Bhola Sadar",
      lat: "22.685923",
      lon: "90.648179",
      url: "www.bhola.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "35",
      division_id: "4",
      district_name: "Barguna",
      bn_name: "বরগুনা",
      upazila_name: "Barguna Sadar",
      lat: "22.159182",
      lon: "90.125581",
      url: "www.barguna.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "36",
      division_id: "5",
      district_name: "Sylhet",
      bn_name: "সিলেট",
      upazila_name: "Sylhet Sadar",
      lat: "24.8897956",
      lon: "91.8697894",
      url: "www.sylhet.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "37",
      division_id: "5",
      district_name: "Moulvibazar",
      bn_name: "মৌলভীবাজার",
      upazila_name: "Moulvibazar Sadar",
      lat: "24.482934",
      lon: "91.777417",
      url: "www.moulvibazar.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "38",
      division_id: "5",
      district_name: "Habiganj",
      bn_name: "হবিগঞ্জ",
      upazila_name: "Habiganj Sadar",
      lat: "24.374945",
      lon: "91.41553",
      url: "www.habiganj.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "39",
      division_id: "5",
      district_name: "Sunamganj",
      bn_name: "সুনামগঞ্জ",
      upazila_name: "Sunamganj Sadar",
      lat: "25.0658042",
      lon: "91.3950115",
      url: "www.sunamganj.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "40",
      division_id: "6",
      district_name: "Narsingdi",
      bn_name: "নরসিংদী",
      upazila_name: "Narsingdi Sadar",
      lat: "23.932233",
      lon: "90.71541",
      url: "www.narsingdi.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "41",
      division_id: "6",
      district_name: "Gazipur",
      bn_name: "গাজীপুর",
      upazila_name: "Gazipur Sadar",
      lat: "24.0022858",
      lon: "90.4264283",
      url: "www.gazipur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "42",
      division_id: "6",
      district_name: "Shariatpur",
      bn_name: "শরীয়তপুর",
      upazila_name: "Shariatpur Sadar",
      lat: "23.2060195",
      lon: "90.3477725",
      url: "www.shariatpur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "43",
      division_id: "6",
      district_name: "Narayanganj",
      bn_name: "নারায়ণগঞ্জ",
      upazila_name: "Narayanganj Sadar",
      lat: "23.63366",
      lon: "90.496482",
      url: "www.narayanganj.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "44",
      division_id: "6",
      district_name: "Tangail",
      bn_name: "টাঙ্গাইল",
      upazila_name: "Tangail Sadar",
      lat: "24.264145",
      lon: "89.918029",
      url: "www.tangail.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "45",
      division_id: "6",
      district_name: "Kishoreganj",
      bn_name: "কিশোরগঞ্জ",
      upazila_name: "Kishoreganj Sadar",
      lat: "24.444937",
      lon: "90.776575",
      url: "www.kishoreganj.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "46",
      division_id: "6",
      district_name: "Manikganj",
      bn_name: "মানিকগঞ্জ",
      upazila_name: "Manikganj Sadar",
      lat: "23.8602262",
      lon: "90.0018293",
      url: "www.manikganj.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "47",
      division_id: "6",
      district_name: "Dhaka",
      bn_name: "ঢাকা",
      upazila_name: "Dhaka Sadar",
      lat: "23.7115253",
      lon: "90.4111451",
      url: "www.dhaka.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "48",
      division_id: "6",
      district_name: "Munshiganj",
      bn_name: "মুন্সিগঞ্জ",
      upazila_name: "Munshiganj Sadar",
      lat: "23.5435742",
      lon: "90.5354327",
      url: "www.munshiganj.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "49",
      division_id: "6",
      district_name: "Rajbari",
      bn_name: "রাজবাড়ী",
      upazila_name: "Rajbari Sadar",
      lat: "23.7574305",
      lon: "89.6444665",
      url: "www.rajbari.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "50",
      division_id: "6",
      district_name: "Madaripur",
      bn_name: "মাদারীপুর",
      upazila_name: "Madaripur Sadar",
      lat: "23.164102",
      lon: "90.1896805",
      url: "www.madaripur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "51",
      division_id: "6",
      district_name: "Gopalganj",
      bn_name: "গোপালগঞ্জ",
      upazila_name: "Gopalganj Sadar",
      lat: "23.0050857",
      lon: "89.8266059",
      url: "www.gopalganj.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "52",
      division_id: "6",
      district_name: "Faridpur",
      bn_name: "ফরিদপুর",
      upazila_name: "Faridpur Sadar",
      lat: "23.6070822",
      lon: "89.8429406",
      url: "www.faridpur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "53",
      division_id: "7",
      district_name: "Panchagarh",
      bn_name: "পঞ্চগড়",
      upazila_name: "Panchagarh Sadar",
      lat: "26.3411",
      lon: "88.5541606",
      url: "www.panchagarh.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "54",
      division_id: "7",
      district_name: "Dinajpur",
      bn_name: "দিনাজপুর",
      upazila_name: "Dinajpur Sadar",
      lat: "25.6217061",
      lon: "88.6354504",
      url: "www.dinajpur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "55",
      division_id: "7",
      district_name: "Lalmonirhat",
      bn_name: "লালমনিরহাট",
      upazila_name: "Lalmonirhat Sadar",
      lat: "25.9165451",
      lon: "89.4532409",
      url: "www.lalmonirhat.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "56",
      division_id: "7",
      district_name: "Nilphamari",
      bn_name: "নীলফামারী",
      upazila_name: "Nilphamari Sadar",
      lat: "25.931794",
      lon: "88.856006",
      url: "www.nilphamari.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "57",
      division_id: "7",
      district_name: "Gaibandha",
      bn_name: "গাইবান্ধা",
      upazila_name: "Gaibandha Sadar",
      lat: "25.328751",
      lon: "89.528088",
      url: "www.gaibandha.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "58",
      division_id: "7",
      district_name: "Thakurgaon",
      bn_name: "ঠাকুরগাঁও",
      upazila_name: "Thakurgaon Sadar",
      lat: "26.0336945",
      lon: "88.4616834",
      url: "www.thakurgaon.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "59",
      division_id: "7",
      district_name: "Rangpur",
      bn_name: "রংপুর",
      upazila_name: "Rangpur Sadar",
      lat: "25.7558096",
      lon: "89.244462",
      url: "www.rangpur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "60",
      division_id: "7",
      district_name: "Kurigram",
      bn_name: "কুড়িগ্রাম",
      upazila_name: "Kurigram Sadar",
      lat: "25.805445",
      lon: "89.636174",
      url: "www.kurigram.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "61",
      division_id: "8",
      district_name: "Sherpur",
      bn_name: "শেরপুর",
      upazila_name: "Sherpur Sadar",
      lat: "25.0204933",
      lon: "90.0152966",
      url: "www.sherpur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "62",
      division_id: "8",
      district_name: "Mymensingh",
      bn_name: "ময়মনসিংহ",
      upazila_name: "Mymensingh Sadar",
      lat: "24.7471492",
      lon: "90.4202739",
      url: "www.mymensingh.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "63",
      division_id: "8",
      district_name: "Jamalpur",
      bn_name: "জামালপুর",
      upazila_name: "Jamalpur Sadar",
      lat: "24.937533",
      lon: "89.937775",
      url: "www.jamalpur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "64",
      division_id: "8",
      district_name: "Netrokona",
      bn_name: "নেত্রকোণা",
      upazila_name: "Netrokona Sadar",
      lat: "24.870955",
      lon: "90.727887",
      url: "www.netrokona.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "65",
      division_id: "9",
      district_name: "Shariatpur",
      bn_name: "শরীয়তপুর",
      upazila_name: "Shariatpur Sadar",
      lat: "23.2060195",
      lon: "90.3477725",
      url: "www.shariatpur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "66",
      division_id: "9",
      district_name: "Madaripur",
      bn_name: "মাদারীপুর",
      upazila_name: "Madaripur Sadar",
      lat: "23.164102",
      lon: "90.1896805",
      url: "www.madaripur.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "67",
      division_id: "9",
      district_name: "Rajbari",
      bn_name: "রাজবাড়ী",
      upazila_name: "Rajbari Sadar",
      lat: "23.7574305",
      lon: "89.6444665",
      url: "www.rajbari.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "68",
      division_id: "9",
      district_name: "Gopalganj",
      bn_name: "গোপালগঞ্জ",
      upazila_name: "Gopalganj Sadar",
      lat: "23.0050857",
      lon: "89.8266059",
      url: "www.gopalganj.gov.bd",
      delivery_charges: 180,
    },
    {
      id: "69",
      division_id: "9",
      district_name: "Faridpur",
      bn_name: "ফরিদপুর",
      upazila_name: "Faridpur Sadar",
      lat: "23.6070822",
      lon: "89.8429406",
      url: "www.faridpur.gov.bd",
      delivery_charges: 180,
    },
  ];
  
  export default AllDistrict;